export const KANBAN_STALE_REPORT_IN_MS = 1000 * 60 * 60 * 3; // 3 hours
